<script setup lang="ts">
import { computed } from 'vue'
import { useDesignStore } from '../../store/useDesignStore'

const store = useDesignStore()
const layers = computed(() => (store.activeDoc?.layers ?? []).slice().reverse())
function label(l: any) {
  if (l.name) return l.name
  if (l.type === 'text') return l.text ? `„${String(l.text).slice(0, 18)}“` : 'Text'
  if (l.type === 'image') return l.source.kind === 'placeholder' ? 'Leerer Bild-Slot' : 'Bild'
  if (l.type === 'sticker') return 'Sticker'
  return 'Form'
}
function toggleVisible(id: string, visible: boolean) {
  store.beginTxn()
  store.patchLayer(id, { visible } as any)
  store.commitTxn()
}
</script>

<template>
  <div class="lp">
    <div v-if="!layers.length" class="lp__empty">Keine Ebenen</div>
    <button
      v-for="l in layers"
      :key="l.id"
      type="button"
      class="lp__row"
      :class="{ 'lp__row--on': store.selection.includes(l.id), 'lp__row--hidden': !l.visible }"
      @click="store.select([l.id])"
    >
      <span class="lp__type">{{ l.type === 'image' ? '🖼' : l.type === 'text' ? 'T' : l.type === 'sticker' ? '★' : '◆' }}</span>
      <span class="lp__label">{{ label(l) }}</span>
      <span v-if="l.constraints.locked" class="lp__lock" title="Gesperrt">🔒</span>
      <span class="lp__eye" role="button" :title="l.visible ? 'Ausblenden' : 'Einblenden'" @click.stop="toggleVisible(l.id, !l.visible)">{{ l.visible ? '👁' : '◌' }}</span>
    </button>
  </div>
</template>

<style scoped>
.lp { display: grid; gap: 2px; padding: 8px; }
.lp__empty { padding: 8px; font-size: 12px; color: var(--pfe-color-muted, rgba(15, 23, 42, 0.62)); }
.lp__row { display: grid; grid-template-columns: 22px 1fr auto auto; align-items: center; gap: 6px; padding: 6px 8px; border: 1px solid transparent; border-radius: 6px; background: transparent; text-align: left; font: inherit; font-size: 13px; cursor: pointer; }
.lp__row:hover { background: rgba(15, 23, 42, 0.05); }
.lp__row--on { border-color: var(--pfe-color-accent, #e30b17); background: rgba(227, 11, 23, 0.06); }
.lp__row--hidden { opacity: 0.55; }
.lp__label { overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.lp__eye, .lp__lock { font-size: 13px; }
</style>
